import { NgModule } from '@angular/core';
import { FuseCardModule } from '@fuse/components/card';
import { FuseAlertModule } from '@fuse/components/alert';
import { SharedModule } from 'app/shared/shared.module';
import { DirectivesModule } from 'app/directives/directive.module';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatPaginatorTranslator } from './mat-paginator-translator';
import { MatCustomTableComponent } from './mat-custom-table.component';
@NgModule({
    declarations: [MatCustomTableComponent],
    imports: [
        CommonModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        SharedModule,
        FuseCardModule,
        FuseAlertModule,
        DirectivesModule,
        MatTableModule,
        MatSelectModule,
        MatSortModule,
        MatPaginatorModule,
    ],
    providers: [
        DatePipe,
        {
            provide: MatPaginatorIntl,
            useClass: MatPaginatorTranslator
        }
    ],
    exports: [
        MatCustomTableComponent
    ]
})
export class MatCustomTableModule { }
